export const IDS = {
  prefix: 'leo1024BG',
  element: 'ChatInputMobileV2',
  mainChatInput: 'mainChatInput',
  specialShowChatInput: 'specialShowChatInput',
};
